import gql from 'graphql-tag';
import { BankFragment } from '../fragments/bank.fragment';

export const UPDATE_ONE_BANK = gql`
    mutation(
        $input: UpdateOneBankInput!
    ) {
        updateOneBank (
            input: $input
            ) {
            ...BankInfo
        }
    }
    ${BankFragment}
`;